// SidebarSettings — the mobile drawer's Settings page. Replaces AccountModal
// on phones: instead of floating a dialog over the drawer that opened it, the
// drawer drills down one level. Navigation state is owned by
// AuthenticatedLayout; this component only reports "back".
import React from 'react';
import BiometricLoginToggle from '../Account/BiometricLoginToggle';
import './SidebarSettings.css';

const SidebarSettings = ({ onBack }) => (
  <div className="sidebar-settings" role="region" aria-label="Settings">
    <div className="sidebar-settings__header">
      <button
        type="button"
        className="sidebar-settings__back"
        onClick={onBack}
        aria-label="Back to menu"
      >
        <i className="fas fa-arrow-left" aria-hidden="true"></i>
      </button>
      <h2 className="sidebar-settings__title">Settings</h2>
    </div>

    <div className="sidebar-settings__body">
      <BiometricLoginToggle />
    </div>
  </div>
);

export default SidebarSettings;
